export interface PainPoint {
  title: string
  description: string
}

export const painPoints: PainPoint[] = [
  {
    title: 'Non sono un’artista',
    description:
      'Devi insegnare Arte e Immagine ma non hai una formazione specifica, e hai paura di sbagliare le tecniche.',
  },
  {
    title: 'Zero tempo per preparare',
    description:
      'Tra programmazioni, verifiche e burocrazia, non ti resta tempo per creare materiali artistici da zero.',
  },
  {
    title: 'Materiali sparsi e incoerenti',
    description: 'Immagini trovate online, livelli sbagliati, nessuna progressione reale da un anno all’altro.',
  },
]
